import { render, staticRenderFns } from "./_SalesItem.vue?vue&type=template&id=6ff13c0f&scoped=true&"
import script from "./_SalesItem.vue?vue&type=script&lang=js&"
export * from "./_SalesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff13c0f",
  null
  
)

export default component.exports